














































import { Component, Vue, Prop } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import { BButton, BIconPlus, BModal } from 'bootstrap-vue';
import DataTable from '@/components/DataTable.vue';
import TaskFilter from '@/components/TaskFilter.vue';
import TaskFilterOptions from '@/types/TaskFilterOptions';
import TaskList from '@/components/TaskList.vue';
import TaskDetails from '@/components/TaskDetails.vue';
import Authorization, { PermissionScope } from '../types/Authorization';

@Component({
    components: {
        'default-layout': DefaultLayout,
        'data-table': DataTable,
        'task-filter': TaskFilter,
        'task-list': TaskList,
        'b-btn': BButton,
        'b-icon-plus': BIconPlus,
        'b-modal': BModal,
        'task-details': TaskDetails
    }
})
export default class TasksView extends Vue {
    @Prop() projectId!: string;

    taskId = ''
    showModal = false;
    refreshList = false;
    modalTitle = '';
    filter: TaskFilterOptions = {
        sequenceOrName: null,
        isActive: true,
        projectId: null
    }

    get canEditTask() {
        return Authorization.checkAccessRights(this.$appUser, Authorization.operations.editTask, undefined, PermissionScope.Project);
    }

    onTaskSelected(id: string) {
        this.taskId = id;
        this.modalTitle = this.$t('modal.taskDetailsTitle') as string;
        this.showModal = true;
    }

    onLoadComplete() {
        this.refreshList = false;
    }

    onTaskSaved(result: boolean) {
        this.showModal = false;

        if (result) {
            this.refreshList = true;
        }
    }

    onTaskDeleted() {
        this.showModal = false;
        this.refreshList = true;
    }

    addNewTask() {
        this.taskId = '';
        this.modalTitle = this.$t('modal.newTaskTitle') as string;
        this.showModal = true;
    }

    onFilterList(filter: TaskFilterOptions) {
        this.filter = filter;
        this.refreshList = true;
    }
}
